/**
 * NewsButton Component
 * Displays news icon with animated badge for new releases
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import './NewsButton.css';

const NewsButton = () => {
  const navigate = useNavigate();
  const [hasNewRelease, setHasNewRelease] = useState(false);

  useEffect(() => {
    checkForNewRelease();
    
    // Listen for releaseViewed event from News page
    const handleReleaseViewed = () => {
      checkForNewRelease();
    };
    
    window.addEventListener('releaseViewed', handleReleaseViewed);
    
    return () => {
      window.removeEventListener('releaseViewed', handleReleaseViewed);
    };
  }, []);

  const checkForNewRelease = async () => {
    try {
      // Fetch version information
      const response = await fetch(`${config.bffUrl}/api/versions`);
      const result = await response.json();
      
      if (result.success && result.data.lastUpdated) {
        const lastUpdated = result.data.lastUpdated;
        const lastViewedRelease = localStorage.getItem('lastViewedRelease');
        
        // Show animation if there's a new release or user hasn't viewed any release yet
        if (!lastViewedRelease || lastViewedRelease !== lastUpdated) {
          setHasNewRelease(true);
        } else {
          setHasNewRelease(false);
        }
      }
    } catch (error) {
      console.error('Failed to check for new releases:', error);
    }
  };

  const handleClick = () => {
    navigate('/news');
  };

  return (
    <div className="news-button-container">
      <button 
        className="news-button"
        onClick={handleClick}
        aria-label="What's New"
        title="What's New"
      >
        <svg 
          className="news-icon" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
        </svg>
        
        {hasNewRelease && (
          <span className="news-badge pulse">
            New
          </span>
        )}
      </button>
    </div>
  );
};

export default NewsButton;
